<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划单号">
              <global-select
                :value.sync="queryParams.planCode"
                selectType="selectSearch"
                requestApi="/scp/scpDmSporadic/scpDmCodeList"
                :selectItem="{ value: 'label', label: 'label' }"
                searchParam="inputString" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码">
              <global-select
                :assembleLabel="false"
                :value.sync="queryParams.itemCode"
                selectType="selectSearch"
                requestApi="/mes/mesDiscreteJobs/assemblyBox"
                :selectItem="{ value: 'selectedValue', label: 'selectedValue' }"
                searchParam="itemCode" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="来源单号">
              <global-select
                :value.sync="queryParams.sourceCode"
                selectType="selectSearch"
                requestApi="/scp/scpFcSporadic/scpFcCodeList"
                :selectItem="{ value: 'label', label: 'label' }"
                searchParam="inputString" />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <!-- <a-form-item label="需求交期">
                <a-date-picker valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" v-model="queryParams.demandDeliveryDate" />
              </a-form-item> -->
              <a-form-item label="需求交期">
                <a-range-picker
                  class="rp-width"
                  :placeholder="['需求交期从', '需求交期至']"
                  valueFormat="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  :value="demandDeliveryDate"
                  @change="handlePanelChange"
                />
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="提交人">
                <global-select
                  ref="createBySearchRef"
                  selectType="selectAssembleSearchByKey"
                  :value.sync="queryParams.submittedBy"
                  requestApi="/scp/scpFcSporadic/applicantBox"
                  :selectItem="{ value: 'realValue', label: 'label' }"
                  :showLabel="{ value: 'realValue', label: 'label', selectedValue: 'selectedValue' }"
                  searchParam="name"
                />
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="项目组">
                <a-select :max-tag-count="1" show-search allowClear option-filter-prop="children" v-model="queryParams.projectTeam" >
                  <a-select-option v-for="(item) in projectTeams" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="distributeMsg(3)" type="primary">审核</a-button>
      <a-button @click="distributeMsg(1)" type="primary">驳回</a-button>
      <!-- <a-button :disabled="this.queryParams.dmStatus!=='2'" @click="distributeMsg(4)" v-hasPermi="['mdm:mdmUomUnitsOfMeasure:export']">作废</a-button> -->
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          rowKey="id"
          @selectedRowChange="selectedRowChange"
          :scroll="{ fixScreen: true, x: 1300 }"
        >
          <!-- 主要代码在这里 -- 下面这些 -->
          <template slot="bzbz" slot-scope="{ text }">
            <a-tooltip placement="top">
              <template slot="title">
                <span>{{ text }}</span>
              </template>
              <span class="ellipsis">{{ text }}</span>
            </a-tooltip>
          </template>
          <span slot="indexId" slot-scope="{index}">
            {{ index+1 }}
          </span>
          <span slot="planQuantity" slot-scope="{ record, text }">
            <a @click="handleOperation(text,record)" class="ml10">{{ record.planQuantity?record.planQuantity:0 }}</a>
          </span>
          <template slot="demandType" slot-scope="{ record }">
            <a-select v-model="record.demandType" @change="(val)=>handleDemandTypeChange(val,record)">
              <a-select-option v-for="(item) in orderType" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
            </a-select>
          </template>
          <template slot="isStopFlag" slot-scope="{ record }">
            <span >{{ record.isStopFlag === 'Y' ? '是' : '否' }}</span>
          </template>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="demandDeliveryDate" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY/MM/DD') }}</span>
          </template>
          <template slot="expirationDate" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY/MM/DD') }}</span>
          </template>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="time" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY/MM/DD HH:mm') }}</span>
          </template>
          <template slot="status" slot-scope="{ record }">
            <a-popconfirm
              ok-text="确定"
              cancel-text="取消"
              @confirm="confirmHandleStatus(record)"
              @cancel="cancelHandleStatus(record)"
            >
              <span slot="title">请确认是否<b>{{ record.status === 'Y' ? '停用' : '启用' }}</b>该单位</span>
              <a-switch :checked="record.status === 'Y'" />
            </a-popconfirm>
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)">编辑</a>
            <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
        <create-form
          ref="createModal"
          :id="cfId"
          :planQuantity="planQuantity"
          :demandDeliveryDate="demandDeliveryDate"
          @handle-success="onSearch"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

    <script>
    import { generateLsTableResData } from '@/utils/util.js'
    import { apiScpDmSporadicList, apiScpDmSporadic, apiScpDmSporadicState } from '@/api/scp/sporadic-demand/sporadic-demand'
    import CreateForm from './components/CreateForm'
    import moment from 'moment';

    export default {
      // eslint-disable-next-line
      name: 'Requirement-approval',
      components: {
          CreateForm
      },
      data () {
        return {
          demandDeliveryDate: undefined,
          projectTeams: [], // 项目组
          orderType: [],
          cfId: '',
          // 表格配置1
          tableProps: {
            requestApi: generateLsTableResData(apiScpDmSporadicList, true),
            pageCurrent: true
          },
          // 控制搜索展开
          advanced: true,
          // 查询参数
          queryParams: {
            submittedBy: undefined,
            projectTeam: undefined,
            planCode: undefined,
            dmStatus: '2',
            demandDeliveryDate: undefined,
            itemCode: undefined,
            sourceCode: undefined,
            applicantList: undefined
          },
          // 表格多选
          selectedRowKeys: [],
          selectedRows: [],
          // 状态快码
          statusOptions: [
            {
              dictLabel: "未下发",
              dictValue: "1"
            },
            {
              dictLabel: "已下发",
              dictValue: "2"
            },
            {
              dictLabel: "已下单",
              dictValue: "3"
            },
            {
              dictLabel: "已作废",
              dictValue: "4"
            }
          ],
          baseUomFlagOptions: [
            {
              dictLabel: "是",
              dictValue: "Y"
            },
            {
              dictLabel: "否",
              dictValue: "N"
            }
          ],
          // 表格字段
          columns: [
            { title: '序号', scopedSlots: { customRender: 'indexId' }, dataIndex: 'indexId', stickyFixed: 'left', align: 'center', width: 60 },
            { title: '计划单号', dataIndex: 'planCode', ellipsis: true, width: 140, stickyFixed: 'left', align: 'center' },
            { title: '物料编码', dataIndex: 'itemCode', ellipsis: true, width: 140, stickyFixed: 'left', align: 'center' },
            { title: '物料名称', stickyFixed: 'left', dataIndex: 'itemName', width: 120, ellipsis: true, align: 'center' },
            {
              title: '规格描述',
              stickyFixed: 'left',
              dataIndex: 'specification',
              width: 150,
              align: 'left',
              ellipsis: true
              // scopedSlots: { customRender: 'bzbz' }
            },
            { title: '下单类别', dataIndex: 'orderType', width: 110, align: 'center' },
            { title: '销售类目', dataIndex: 'salesCategory', width: 110, align: 'center' },
            { title: '研发分类', dataIndex: 'developType', width: 110, align: 'center' },
            { title: '口径', dataIndex: 'caliberName', width: 110, align: 'center' },
            { title: '主型号', dataIndex: 'mainModel', ellipsis: true, width: 100, align: 'center' },
            { title: '是否停产', scopedSlots: { customRender: 'isStopFlag' }, dataIndex: 'isStopFlag', width: 100, align: 'center' },
            { title: '需求数量', dataIndex: 'quantityDemand', width: 110, align: 'center' },
            { title: '需求交期', dataIndex: 'demandDeliveryDate', scopedSlots: { customRender: 'demandDeliveryDate' }, width: 120, ellipsis: true, align: 'center' },
            { title: '当月回货需求', dataIndex: 'curMonthReturnDemand', width: 110, align: 'center' },
            { title: '当月回货需求日期', dataIndex: 'curMonthReturnDemandDate', scopedSlots: { customRender: 'formatDate' }, width: 120, align: 'center' },
            { title: '次月回货需求', dataIndex: 'nextMonthReturnDemand', width: 110, align: 'center' },
            { title: '次月回货需求日期', dataIndex: 'nextMonthReturnDemandDate', scopedSlots: { customRender: 'formatDate' }, width: 140, align: 'center' },
            { title: '供应余量', dataIndex: 'supplyRemainQty', width: 110, align: 'center' },
            {
              title: '是否在锁定期内',
              dataIndex: 'inLockFlag',
              width: 100,
              align: 'center',
              customRender: (text, record) => ({ 0: '否', 1: '是' }[record.inLockFlag])
            },
            { title: '需求类型', dataIndex: 'demandDeliveryTypeName', width: 100, align: 'center' },
            { title: 'M+3月预测数量', dataIndex: 'forecastQtyM3', width: 100, align: 'center' },
            { title: 'M+2月预测数量', dataIndex: 'forecastQtyM2', width: 100, align: 'center' },
            { title: 'M+1月预测数量', dataIndex: 'forecastQtyM1', width: 100, align: 'center' },
            {
              title: '三个月内是否可消耗完',
              dataIndex: 'threeMonthConsumeIs',
              width: 100,
              align: 'center',
              customRender: (text, record) => ({ 0: '否', 1: '是' }[record.threeMonthConsumeIs])
            },
            { title: '预计消耗月数', dataIndex: 'expectConsumeMonth', width: 100, align: 'center' },
            { title: '计划数量(总数)', dataIndex: 'planQuantity', scopedSlots: { customRender: 'planQuantity' }, width: 100, align: 'center' },
            { title: '单据类型', dataIndex: 'demandType', width: 180, align: 'center' },
            { title: '签署供应商', dataIndex: 'factoryNameStr', width: 120, align: 'center' },
            { title: '签署数量', dataIndex: 'totalQuantityStr', width: 100, align: 'center' },
            { title: '签署日期', dataIndex: 'contractSignTimeStr', width: 140, ellipsis: true, align: 'center' },
            { title: '当月满足数量', dataIndex: 'curMonthSatisfyQty', width: 100, align: 'center' },
            { title: '当月满足率', dataIndex: 'curMonthSatisfyRate', width: 100, scopedSlots: { customRender: 'curMonthSatisfyRate' }, align: 'center' },
            { title: '次月累计满足数量', dataIndex: 'nextMonthAccumulatedSatisfyQty', width: 100, align: 'center' },
            { title: '次月满足率', dataIndex: 'nextMonthSatisfyRate', width: 100, scopedSlots: { customRender: 'nextMonthSatisfyRate' }, align: 'center' },
            { title: '上一版本M+2月发货数量', dataIndex: 'preVersionMonthShipmentQtyM2', width: 100, align: 'center' },
            { title: '上一版本M+1月发货数量', dataIndex: 'preVersionMonthShipmentQtyM1', width: 100, align: 'center' },
            { title: '上一版本M月发货数量', dataIndex: 'preVersionMonthShipmentQtyM', width: 100, align: 'center' },
            { title: '最新版本M+2月发货数量', dataIndex: 'latestVersionMonthShipmentQtyM2', width: 100, align: 'center' },
            { title: '最新版本M+1月发货数量', dataIndex: 'latestVersionMonthShipmentQtyM1', width: 100, align: 'center' },
            { title: '最新版本M月发货数量', dataIndex: 'latestVersionMonthShipmentQtyM', width: 100, align: 'center' },
            { title: 'M+2月已提零星预测', dataIndex: 'providedSporadicPredictQtyM2', width: 100, align: 'center' },
            { title: 'M+1月已提零星预测', dataIndex: 'providedSporadicPredictQtyM1', width: 100, align: 'center' },
            { title: 'M月已提零星预测', dataIndex: 'providedSporadicPredictQtyM', width: 100, align: 'center' },
            { title: '第一层(现有供应余量可覆盖)', dataIndex: 'firstLayer', width: 100, align: 'center' },
            { title: '第二层(加单基线内)', dataIndex: 'secondLayer', width: 100, align: 'center' },
            { title: '第三层(超出加单基线)', dataIndex: 'thirdLayer', width: 100, align: 'center' },
            { title: 'M月销量', dataIndex: 'salesQuantityM', width: 100, align: 'center' },
            { title: 'M-1月销量', dataIndex: 'salesQuantityM1', width: 100, align: 'center' },
            { title: 'M-2月销量', dataIndex: 'salesQuantityM2', width: 100, align: 'center' },
            { title: 'M月在途', dataIndex: 'inTransitVolumeM', width: 100, align: 'center' },
            { title: '库存现货实数', dataIndex: 'stockInventory', width: 100, align: 'center' },
            { title: '来源单号', dataIndex: 'sourceCode', width: 150, ellipsis: true, align: 'center' },
            { title: '状态', dataIndex: 'dmStatusDesc', width: 90, ellipsis: true, align: 'center' },
            { title: '创建人', dataIndex: 'createName', width: 100, ellipsis: true, align: 'center' },
            { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'time' }, width: 140, ellipsis: true, align: 'center' },
            { title: '提交人', dataIndex: 'submittedByName', width: 100, align: 'center' },
            { title: '提交时间', dataIndex: 'submissionTime', scopedSlots: { customRender: 'time' }, width: 140, ellipsis: true, align: 'center' },
            { title: '审核人', dataIndex: 'checkedByName', width: 100, align: 'center' },
            { title: '审核时间', dataIndex: 'checkTime', scopedSlots: { customRender: 'time' }, width: 140, ellipsis: true, align: 'center' },
            { title: '作废人', dataIndex: 'nullifier', width: 100, align: 'center' },
            { title: '作废时间', dataIndex: 'nullifierTime', scopedSlots: { customRender: 'time' }, width: 140, ellipsis: true, align: 'center' },
            { title: '项目组', dataIndex: 'projectTeam', width: 120, align: 'center' }
            // ,
            // {
            //   title: '操作',
            //   width: 100,
            //   dataIndex: 'operation',
            //   scopedSlots: { customRender: 'operation' },
            //   fixed: 'right'
            // }
          ],
          uomClassOptions: [],
          unitOfMeasureList: []
        }
      },
      created () {
        this.getLookupList('SCP_DOC_TYPE', 'orderType')
        this.getLookupList('SCP_PROJECT_TEAM', 'projectTeams')
      },
      mounted () {
        this.onSearch()
      },
      methods: {
      handleDemandTypeChange (val, record) {
        apiScpDmSporadicState({ id: record.id, demandType: val }).then((response) => {
                if (response.code === 200) {
                  this.$message.success('保存成功')
                  // this.onSearch()
                  this.$set(record, 'demandType', val);
                } else {
                  this.$set(record, 'demandType', '');
                  this.$message.error(response.msg)
                }
              })
      },
      getLookupList (type, arr) {
            const lookupQueryParams = {
              lookupType: type,
              current: 1,
              pageSize: 100
            }
            this.getLookupListData(lookupQueryParams).then().then(response => {
              this[arr] = response.rows
            })
      },
       handleOperation (text, record) {
              this.cfId = record.id
              this.demandDeliveryDate = record.demandDeliveryDate ? moment(record.demandDeliveryDate).format('YYYY/MM/DD') : ''
              this.planQuantity = record.quantityDemand ? record.quantityDemand : '0'
              this.$refs.createModal.show(record.id)
          },
          handlePanelChange (value) {
            const yearMonth1 = value[0]
            const yearMonth2 = value[1]
            this.queryParams.demandDeliveryDateFrom = yearMonth1
            this.queryParams.demandDeliveryDateTo = yearMonth2
            this.demandDeliveryDate = value
          },
           /** 行选中 */
       selectedRowChange (selectedRowKeys, selectedRows) {
          this.selectedRowKeys = selectedRowKeys;
          this.selectedRows = selectedRows;
        },
        /**
         *
         * @param {*} type
         * 零星需求：
         * 提交：2
         * 审核通过：3
         * 驳回：1
         * 作废：4
         */
        distributeMsg (type) {
          if (this.selectedRows.length === 0) {
            this.$message.error('请选中操作项')
            return
          }
          let typeTips = ''
          if (type === 1) {
            typeTips = '确定驳回选中数据？'
          } else if (type === 2) {
            typeTips = '确定提交选中数据？'
          } else if (type === 3) {
            typeTips = '确定审核通过选中数据？'
          } else if (type === 4) {
            typeTips = '作废后不可恢复，请确认'
          }
          const self = this
          const newObjectArray = this.selectedRows.map(row => ({ id: row.id }));
          const params = {
            scpDmSporadicList: newObjectArray,
            status: type
          }
          this.$confirm({
            title: `提示`,
            content: typeTips,
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk () {
              apiScpDmSporadic(params).then((response) => {
                if (response.code === 200) {
                  self.$message.success('提交成功')
                  self.onSearch()
                } else {
                  self.$message.error(response.msg)
                }
              })
            }
          })
        },

        // 导入导出excel
        /** 导出按钮操作 */
        handleExport () {
          this.download('scp/scpDmSporadic/export', {
            ...this.queryParams
          }, `零星需求管理_${new Date().getTime()}.xlsx`)
        },
        // confirmHandleStatus (row) {
        //   const text = row.status === 'Y' ? '停用' : '启用'
        //   row.status = row.status === 'Y' ? 'N' : 'Y'
        //   updateUnit(row)
        //   .then(() => {
        //     this.$message.success(
        //       text + '成功',
        //       3
        //     )
        //     this.onSearch()
        //   }).catch(function () {
        //     row.status = row.status === 'Y' ? 'N' : 'Y'
        //     this.$message.error(
        //       text + '发生异常',
        //       3
        //     )
        //   })
        // },
        // cancelHandleStatus (row) {
        // },
        baseUomFlagFormat (row, column) {
          return this.selectDictLabel(this.baseUomFlagOptions, row.baseUomFlag)
        },
        // 表单搜索
        onSearch () {
          this.$refs.dataTable.searchParams = this.queryParams;
          this.$refs.dataTable.getData();
        },
        /** 重置按钮操作 */
        resetQuery () {
          this.queryParams = {
            submittedBy: undefined,
            projectTeam: undefined,
            planCode: undefined,
            dmStatus: '2',
            demandDeliveryDate: undefined,
            itemCode: undefined,
            sourceCode: undefined,
            applicantList: undefined,
            demandDeliveryDateFrom: undefined,
            demandDeliveryDateTo: undefined
          }
          this.demandDeliveryDate = undefined
          this.onSearch()
          this.$refs.createBySearchRef.handleSearch(''); // 重新查询提交人下拉
        },
        // 搜索框展开、收起
        toggleAdvanced () {
          this.advanced = !this.advanced
        }
      }
    }
    </script>

  <style lang="less"  scoped>
    .ml10{
      margin-left: 10px;
    }.ellipsis{
        display:block;
        width:150px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

    </style>
